import type {AppDomainContext} from "app/services/domain/domain.module";
import * as Models from "app/services/proxy/model/models";
import {WidgetChargeTypeCondition} from "app/shared/filters/widget-filter/widget-filtering";
import {findQueryOperatorByType} from "app/shared/query-group/query-operator-query-node";

import {UtilsService} from "framework/services/utils.service";

export type AllocationOrLineItemRuleType = Models.BillingRuleAllocation | Models.BillingRuleCreateLineItemBase;
export type PossibleLogicRuleTypes = Models.BillingRulePercentageCalculate | Models.BillingRuleFixedTiered;

export function extractTypedRules(rules: Models.BillingRule[]): [PossibleLogicRuleTypes[], AllocationOrLineItemRuleType[]]
{
    const pricingRules: PossibleLogicRuleTypes[]                  = [];
    const allocationLineItemRules: AllocationOrLineItemRuleType[] = [];
    for (const rule of rules)
    {
        if (isPricingRule(rule))
        {
            if (rule instanceof Models.BillingRuleFixedCustomRate)
            {
                console.error("unhandled fixed custom rate rule");
            }
            else
            {
                pricingRules.push(<PossibleLogicRuleTypes>rule);
            }
        }
        else
        {
            if (rule instanceof Models.BillingRuleAllocation)
            {
                allocationLineItemRules.push(rule);
            }
            else if (rule instanceof Models.BillingRuleCreateLineItemBase)
            {
                allocationLineItemRules.push(rule);
            }
        }
    }

    return [
        pricingRules,
        allocationLineItemRules
    ];
}

export function isPricingRule(rule: Models.BillingRule): rule is Models.BillingRuleCalculate
{
    return rule instanceof Models.BillingRuleCalculate;
}

export async function getRuleChargeMode(app: AppDomainContext,
                                        rule: Models.BillingRule): Promise<ChargeMode>
{
    const operator = findQueryOperatorByType<Models.BillingLineItemTypeQueryOperator>(rule.scope, Models.BillingLineItemTypeQueryOperator);
    if (!operator) return null;

    const options         = await WidgetChargeTypeCondition.getOptions(app, null, null);
    const indirectOptions = new Set<string>();
    const usageOptions    = new Set<string>();

    const USAGE_GROUP_KEY = "Usage(group)";
    for (const group of options)
    {
        const target = group.id === USAGE_GROUP_KEY ? usageOptions : indirectOptions;
        UtilsService.forEachRecursive([group], option => target.add(option.id));
    }

    // Find an option in either category, first match will determine type
    for (const type of operator.line_item_types)
    {
        if (usageOptions.has(type)) return ChargeMode.Usage;
        if (indirectOptions.has(type)) return ChargeMode.Indirect;
    }

    return null;
}

export enum ChargeMode
{
    Usage    = "usage",
    Indirect = "indirect",
    Custom   = "custom"
}